export function SubmissionErrorMessage({submissionStatus, submissionError, csrfHookInfo}) {
  const displayError = submissionError
    && typeof submissionError === 'object'
    && submissionError.message
    ? submissionError.message
    : submissionError;

  return (
    <div className="mb-6">
      {csrfHookInfo.isLoading && (
        <p className="text-sm text-blue-500">Initializing form security...</p>
      )}

      {submissionStatus === 'submitting' && (
        <p className="text-sm text-blue-500">Sending message...</p>
      )}

      {/* {submissionStatus === 'success' && (
            <p className="text-sm text-green-600 font-semibold">Message sent successfully! We'll be in touch.</p>
            )} */}
      {submissionStatus === 'error' && typeof submissionError === 'string' && (
        <p className="text-sm text-red-600 font-semibold">
          Submission failed. Error -
          {' '}
          {displayError}
        </p>
      )}

      {submissionStatus === 'error' && typeof submissionError !== 'string' && Array.isArray(Object.values(submissionError)) && (
        Object.values(submissionError).map((error, index) => (
          <p key={index} className="text-sm text-red-600 font-semibold mb-2">
            Submission failed. Error -
            {' '}
            {error}
          </p>
        ))
      )}
    </div>
  );
}
